import { render } from "./ViewDevoirPage.vue?vue&type=template&id=a57b1a82&ts=true"
import script from "./ViewDevoirPage.vue?vue&type=script&lang=ts"
export * from "./ViewDevoirPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__